const defaults = {
	btnOption: document.getElementById('btnOption'),
	btnInscription: document.getElementById('btnInscription'),
	selectors: {
		fieldsList: '.field__select, .field__input, .field__textarea',
		fieldClass: '.field',
		fieldClassName: 'field',
		fieldActiveClassName: 'form-field--is-active',
		//		fieldFilledClassName: 'form-field--is-filled',
		fieldErrorClassName: 'form-field--is-error',
		classValidation: 'field-validation-error'
	},
	storageNameRecap: 'recap',
	dataAttributeBlockRecap: 'data-readmore',
	utilities: {
		regexMail: /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/,
		regexTel: /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
		testRegex: function (regex, champ) {
			if (!regex.test(champ)) {
				return false;
			} else {
				return true;
			}
		}
	}
};

class Inscription {
	constructor(config) {
		/// On surcharge {config} par {defaults}
		/// les propriétés de {defaults} ne sont ajoutées que si elles n'existent pas
		this.config = {
			...defaults,
			...config
		};
	}

	initialize() {
		this.entete();
		this.recap();
	}

	debug() {
		console.table(this.config);
	}

	/// Function utilisée pour des requêtes serveur
	/// (mise à jour passagers, recap...)
	_postRequest(url, data) {
		let self = this;

		fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			}).then(res => {
				return res.text();
			}).then(html => {
				document.getElementById('recapVoyage').innerHTML = html;
			}).then(() => {
				// Comme on a rechargé tout le block, on relance les functions utilisées dans le recap du voyage
				let recap = document.getElementById('recapVoyage');
				self.recap(recap.querySelectorAll(`[${self.config.dataAttributeBlockRecap}]`));
				typeof commons.tooltip === 'function' && commons.tooltip();
			})
			.catch(error => console.error(error));
	}

	///
	///
	/// Form
	// form() {
	// 	let self = this;
	// 	//document.addEventListener('DOMContentLoaded', function () {
	// 	self._formAnimation();
	// 	//});
	// }

	// /// Gestion de l'état des champs (focus, actif, rempli...)
	// _formAnimation() {
	// 	let self = this;
	// 	let selectors = self.config.selectors;

	// 	[].forEach.call(
	// 		document.querySelectorAll(selectors.fieldsList),
	// 		(el) => {

	// 			el.onchange = () => {
	// 				el.value != '' && self._animationField(el, false);
	// 			}
	// 			el.onblur = () => {
	// 				self._animationField(el, false);
	// 			}
	// 			el.oninput = () => {
	// 				self._animationField(el, false);
	// 			}
	// 			el.onfocus = () => {
	// 				self._animationField(el, 'focus');
	// 				self._callbackFocus(el);
	// 			}
	// 			el.onanimationstart = () => {
	// 				//console.log(el.value)
	// 				self._animationField(el, true);
	// 			}

	// 			if (el.localName === 'select') {
	// 				self._animationField(el, false);
	// 			} else if (self._placeholderActive(`#${el.id}`)) {
	// 				self._animationField(el, false);
	// 			} else {
	// 				el.value != '' && self._animationField(el, false);
	// 			}
	// 		}
	// 	);
	// }


	/// UTILITIES
	/// permet de détécter si un input a un placeholder
	_placeholderActive(selector) {
		return !!document.querySelector(selector + ':placeholder-shown');
	}

	/// Utility : submit du form
	_submitForm(id, submitBtn) {
		let form = document.getElementById(id);
		let submitButton = form.querySelector(`#${submitBtn}`);

		if (form.requestSubmit) {
			if (submitButton) {
				form.requestSubmit(submitButton);
			} else {
				form.requestSubmit();
			}
		} else {
			form.submit();
		}
	}

	/// Utility : toggle state du btn de validation
	// _stateValidButton(isValid, btn) {
	// 	if (isValid) {
	// 		btn.classList.remove('is-disabled');
	// 	} else {
	// 		btn.classList.add('is-disabled');
	// 	}
	// }

	/// Gestion de l'animation du label au focus et au blur
	// _animationField(el, active) {
	// 	let self = this;
	// 	let selectors = self.config.selectors;
	// 	const formField = el.parentNode;

	// 	if (active) {
	// 		formField.classList.remove(selectors.fieldActiveClassName);
	// 		formField.classList.add(selectors.fieldFilledClassName);
	// 	} else if (active === 'focus') {
	// 		formField.classList.add(selectors.fieldActiveClassName)
	// 	} else {
	// 		formField.classList.remove(selectors.fieldActiveClassName)

	// 		if (el.value === '') {
	// 			self._placeholderActive(`#${el.id}`) ? formField.classList.add(selectors.fieldFilledClassName) :
	// 				formField.classList.remove(selectors.fieldFilledClassName);
	// 			if (el.localName === 'select') {
	// 				el.options[el.selectedIndex].text === '--' ? formField.classList.add(selectors.fieldFilledClassName) :
	// 					formField.classList.remove(selectors.fieldFilledClassName);
	// 			}
	// 		} else {
	// 			formField.classList.add(selectors.fieldFilledClassName);
	// 		}
	// 	}
	// }

	/// Au cas où le champ soit en erreur,
	/// au focus, on retire l'erreur
	_callbackFocus(el) {
		let self = this;
		let selectors = self.config.selectors;

		const field = el.parentNode.classList.contains(selectors.fieldClassName) ? el.parentNode : el.parentNode.parentNode;
		field.classList.remove(selectors.fieldErrorClassName);
	}


	///
	///
	/// Gestion du block étapes
	entete() {
		let self = this;

		let steps = document.querySelector('.steps');

		if (steps === null) {
			return false;
		}

		let li = steps.querySelectorAll('.steps-segment');
		li[config.step - 1].classList.add('is-active');
		for (var i = 0; i < config.step - 1; i++) {
			li[i].classList.add('is-complete');
		}
		/*
				let info = li[config.step - 1].getBoundingClientRect();

				if (document.body.getBoundingClientRect().width < 768) {
					li.forEach(function (el) {
						let left = `50% - 12px - ${info.left}px - ${info.width}px / 2`; // On centre le <li> : 50% - PaddingRight - MarginLeftUl - positionLeftLi - moitiéWidthLi
						el.style.left = `calc(${left})`;
					});
				}*/

		/// On bloque le retour arrière sur les pages de confirmation
		if (config.page != 'confirmation') {
			/// On ne garde que les <li> qui ont un attribut data-step
			let etapes = [];
			for (let etape of li) {
				if (etape.dataset.step != null) {
					etapes.push(etape)
				}
			}
			etapes.forEach(function (el) {
				el.addEventListener('click', function (e) {
					e.preventDefault();
					self._goToEntete(el);
				});
			});
		}

	}

	// Gestion retour à une page précédente depuis le steps
	// @TODO gerer submit sans jQuery
	_goToEntete(el) {
		let self = this;
		let msgPagePaiement = "Vous êtes en train de réaliser une opération importante. Êtes-vous sûrs de vouloir quitter la page ?";

		let etape = this.config.step;
		// On vérifie que l'on clique bien sur une étape précédente
		let isStepPrev = parseInt(el.dataset.step) < etape;

		if (isStepPrev) {
			let url = el.dataset.urlStep;
			if (document.getElementById('HiddenUrlEnteteClick') !== null) {
				document.getElementById('HiddenUrlEnteteClick').value = url;
			}

			switch (el.dataset.pageStep) {
			case "nb_voyageurs":
				if (etape == 2 && this.config.page == 'coordonnees')
					$("#infosCoordonneesForm").submit();
				else if (etape == 3)
					$("#optionsForm").submit();
				else if (etape == 4) {
					self._confirmBackPopup(msgPagePaiement, 'voyageurs', url);
				} else
					window.location.href = url;
				break;

			case "coordonnees_voyageurs":
				if (etape == 3) {
					$('[name="precedent"]').trigger('click');
				} else if (etape == 4) {
					self._confirmBackPopup(msgPagePaiement, 'coordonnées', url);
				}
				break;

			case "options-assurances":
				if (etape == 4) {
					self._confirmBackPopup(msgPagePaiement, 'options', url);
				}
				if (etape == 2 && config.path === "relance") {
					self._confirmBackPopup(msgPagePaiement, 'Votre voyage', url);
				}
				break;

			default:
				console.error(`Le nom de page "${el.dataset.pageStep}" est inconnu.`)
			}
		}
	}

	/// Appel d'une modale en cas de retour arrière
	_confirmBackPopup(msg, page, url) {
		modalPopup.callback = function () {
			document.getElementById('popupValidButton').classList.remove('btn--action');
			document.getElementById('popupValidButton').addEventListener('click', function () {
				window.location.href = url;
			})
			document.getElementById('popupCancelButton').addEventListener('click', function () {
				modalPopup.close();
			})
		}
		modalPopup.callback();
		modalPopup.init(msg, 'Voulez-vous vraiment quitter la page ?', 'Annuler', `Revenir à la page ${page}`)
	}

	///
	///
	/// Toggle blocks du récapitulatif
	recap(element) {
		let self = this;
		let el = element || document.querySelectorAll(`[${self.config.dataAttributeBlockRecap}]`);
		let dataStorageRecap = window.sessionStorage.getItem(self.config.storageNameRecap);
		/// Si aucun élément n'est enregistré
		/// On enregistre l'état des éléments
		if (dataStorageRecap === null) {
			self._initStateRecap(el)
		}
		/// Sinon on met à jour la colonne récap
		else {
			self._getStateRecap(el, dataStorageRecap);
		}

		/// Événement click sur un block
		el.forEach(element => {
			element.addEventListener('click', function (el) {
				let newValue = !JSON.parse(el.target.getAttribute(self.config.dataAttributeBlockRecap));
				el.target.setAttribute(self.config.dataAttributeBlockRecap, newValue);
				let obj = {};
				let nameBlock = el.target.dataset.readmoreBlock;
				obj[nameBlock] = newValue;

				try {
					self._updateStateRecap(obj)
				} catch (e) {
					console.error(e)
				}
			});
		});

		let btnPDF = document.getElementById('btnModalPDF');
		if (config.page != 'tunnel' && btnPDF !== null) {
			btnPDF.addEventListener('click', function (el) {
				commons.loader.loading();
				let url = el.target.dataset.urlPdf;
				self.modalFicheTechnique(url + config.codeProduit);
			});
		}

		if(this.config.isSuisse) {
			settingsApp.modules.componentTooltip.then((e) => {
				let component = require('components/tooltip');
				new component()
			}).catch((err) => {
				console.error(err)
			})
		}
	}

	/// On enregistre dans un sessionStorage
	/// l'état d'ouverture des blocks du récap
	_initStateRecap(element) {
		let self = this;
		let stateRecap = {};

		element.forEach(el => {
			let id = el.dataset.readmoreBlock;
			stateRecap[id] = JSON.parse(el.getAttribute(self.config.dataAttributeBlockRecap));
		});
		window.sessionStorage.setItem(self.config.storageNameRecap, JSON.stringify(stateRecap));
	}

	/// On récupère l'état d'ouverture des blocks du récap
	/// depuis le sessionStorage
	_getStateRecap(element, storageStateRecap) {
		let self = this;

		element.forEach(el => {
			let id = el.dataset.readmoreBlock;
			let value = JSON.parse(storageStateRecap)[id] === undefined ? el.dataset.readmore : JSON.parse(storageStateRecap)[id];
			el.setAttribute(self.config.dataAttributeBlockRecap, value);
		});
	}

	/// On ouvre / ferme le block récap
	/// on enregistre le nouvel état dans sessionStorage
	_updateStateRecap(value) {
		let self = this;
		let prevData = JSON.parse(sessionStorage.getItem(self.config.storageNameRecap));

		Object.keys(value).forEach(function (val) {
			prevData[val] = value[val];
		})
		sessionStorage.setItem(self.config.storageNameRecap, JSON.stringify(prevData));
	}

	/// Uniquement sur les pages de relance
	modalFicheTechnique(url) {
		let self = this;
		var myHeaders = new Headers();
		var myInit = {
			method: 'GET',
			headers: myHeaders,
			mode: 'cors',
			cache: 'default'
		};

		fetch(url, myInit).then(res => {
			return res.text();
		}).then(data => {
			modalPopup.overrideStyles = false;
			modalPopup.init("", "Demande de fiche technique");
			document.querySelector(modalPopup.items.popupModal).classList.add('modal--ficheTechnique');
			document.getElementById('popupContent').innerHTML = data;
			commons.loader.loaded();
		}).then(el => {
			let btnValidation = document.getElementById('btnDemandeFT');
			self._checkDataFt(btnValidation);
			/// On n'ajoute qu'une seule fois le listener
			if (document.querySelector('.modal--ficheTechnique').dataset.listener === undefined) {
				document.querySelector('.modal--ficheTechnique').addEventListener('click', function (el) {
					self._sendFT(el);
					document.querySelector('.modal--ficheTechnique').setAttribute('data-listener', true);
				});
			}
		}).catch(error => console.error(error));
	}

	_sendFT(el) {
		let self = this;
		if (el.target.id === 'btnDemandeFT') {
			$.ajax({
				url: config.url.pdf,
				async: false,
				type: 'POST',
				data: $('#DemandeFiche').serialize(),
				success: function (data) {
					$('#popupContent').html(data);
				},
				error: function () {
					alert('Une erreur est survenue lors de l\'envoi de la fiche technique');
				},
				complete: function () {
					let btnValidation = document.getElementById('btnDemandeFT');
					btnValidation !== null && self._checkDataFt(btnValidation);
				}
			});
		}
	}

	///
	/// check email demande FT
	_checkDataFt(btn, idEmail = 'Email', idForm = 'DemandeFiche', event = 'focusout') {
		const utilities = new utilitiesInscription(config);
		let emailIsGood = utilities.checkForm(idForm, idEmail);

		document.getElementById(idEmail).addEventListener(event, function () {
			emailIsGood = utilities.checkForm(idForm, idEmail);
		});
	}
}